import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-float-label prime_input mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createTextVNode("Description"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1)
const _hoisted_5 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_component_InputText, {
        type: "text",
        id: "name",
        name: "name",
        modelValue: _ctx.form.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
        autocomplete: "name"
      }, null, 8, ["modelValue"]),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Textarea, {
        modelValue: _ctx.form.description,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.description) = $event)),
        id: "description",
        name: "description",
        autoResize: true,
        rows: "5",
        cols: "30",
        placeholder: "Enter text here...",
        class: "w-100"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        label: "Update",
        icon: "pi pi-refresh",
        class: "p-button-sm p-button-raised mb-1 p-button-primary",
        onClick: _withModifiers(_ctx.editTag, ["prevent"])
      }, null, 8, ["onClick"])
    ])
  ], 32))
}